/**
 * Alert Types Actions
 */
export const EVENT_TYPES_REQUEST_STARTED = 'EVENT_TYPES_REQUEST_STARTED';
export function eventTypesRequestStarted() {
  return {
    type: EVENT_TYPES_REQUEST_STARTED,
    eventtypes: null,
    isFetching: true,
  };
}

export const EVENT_TYPES_FETCHED = 'EVENT_TYPES_FETCHED';
export function eventTypesFetched(eventtypes) {
  return {
    type: EVENT_TYPES_FETCHED,
    eventtypes: eventtypes,
  };
}

export const EVENT_TYPES_REQUEST_ERROR = 'EVENT_TYPES_REQUEST_ERROR';
export function eventTypesRequestError() {
  return {
    type: EVENT_TYPES_REQUEST_ERROR,
  };
}

/**
 * Subscription fetched Actions
 */
export const SUBSCRIPTION_REQUEST_STARTED = 'SUBSCRIPTION_REQUEST_STARTED';
export function subscriptionRequestStarted() {
  return {
    type: SUBSCRIPTION_REQUEST_STARTED,
    subscription: null,
    isFetching: true,
  };
}

export const SUBSCRIPTION_FETCHED = 'SUBSCRIPTION_FETCHED';
export function subscriptionFetched(subscription) {
  return {
    type: SUBSCRIPTION_FETCHED,
    subscription: subscription,
  };
}

export const SUBSCRIPTION_REQUEST_ERROR = 'SUBSCRIPTION_REQUEST_ERROR';
export function subscriptionRequestError() {
  return {
    type: SUBSCRIPTION_REQUEST_ERROR,
  };
}

export const ALERTS_DETAIL_VIEW_OPEN = 'ALERTS_DETAIL_VIEW_OPEN';
export function detailViewOpen(open) {
  return {
    type: ALERTS_DETAIL_VIEW_OPEN,
    open: open,
  };
}
